<template>
  <div class="header">
    <v-app-bar flat color="#eaebf4" app height="60">
      <v-toolbar-title class="d-flex align-center">
        <v-img
          :src="require('@/assets/images/Logo-thumb.png')"
          class="header-logo"
          contain
          width="70px"
        />
        <div class="ms-5">
          <h3> مــــــیـــــراب   &nbsp; مـــــــــن </h3>
          <h6 class="p-fs-s"> اتوماسیون اداری و خدماتی </h6>
        </div>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div>
        <v-btn
                elevation="2"
                icon
                color="first"
                small
                @click="logoutModal = true"
        >
          <v-icon>mdi-power</v-icon>
        </v-btn>
      </div>
    </v-app-bar>

    <!-- logout Modal -->
    <v-dialog
            v-model="logoutModal"
            max-width="100%"
            overlay-color="error"
    >
      <v-card>
        <v-card-title class="modal-header">
          <a class="close-modal" @click="close">
            <v-icon class="mr-1"> mdi-close </v-icon>
          </a>
          <h3 class="mx-auto">خروج از سامانه</h3>
        </v-card-title>
        <v-card-text class="px-0 pb-0">
          <v-row class="mb-1">
            <v-col cols="12" class="mt-3">
              <p class="text-center"> می خواهید از سامانه خارج شوید ؟!</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-5 pt-0 d-flex justify-center">
          <v-btn
                  color="first"
                  dark
                  class="px-5 ml-2"
                  depressed
                  @click="logout"
          >
            بله، خروج
          </v-btn>
          <v-btn
                  color="light"
                  class="px-5"
                  depressed
                  @click="close"
          >
            انصراف
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: "TheHeader",
  data() {
    return {
      logoutModal: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    close() {
      this.logoutModal = false;
    },
  },
  mounted() {
    const userId = localStorage.getItem("myMirabUser");
    if(userId) {
      this.$store.commit("updateUserId", userId);
    }
  }
};
</script>
